import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
} from "@mui/material";
import { Search, Clear } from "@mui/icons-material";

/**
 * Reusable SearchBar component with optional filters
 * 
 * @param {string} value - Search value
 * @param {Function} onChange - Search change handler: (value) => void
 * @param {string} placeholder - Search placeholder
 * @param {Array} filters - Array of filter definitions: [{ name, label, options, value, onChange }]
 * @param {Function} onClear - Clear handler
 * @param {object} sx - Custom styles
 */
const SearchBar = ({
  value = "",
  onChange,
  placeholder = "Search...",
  filters = [],
  onClear,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        flexWrap: "wrap",
        ...sx,
      }}
    >
      <TextField
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        size="small"
        sx={{ flexGrow: 1, minWidth: 200 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={() => {
                  onChange?.("");
                  onClear?.();
                }}
              >
                <Clear />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {filters.map((filter, index) => (
        <FormControl key={index} size="small" sx={{ minWidth: 150 }}>
          <InputLabel>{filter.label}</InputLabel>
          <Select
            value={filter.value || ""}
            label={filter.label}
            onChange={(e) => filter.onChange?.(e.target.value)}
          >
            {filter.options.map((option) => {
              const optValue = typeof option === "string" ? option : option.value;
              const optLabel = typeof option === "string" ? option : option.label;
              return (
                <MenuItem key={optValue} value={optValue}>
                  {optLabel}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      ))}
    </Box>
  );
};

export default SearchBar;

